module.exports = __webpack_public_path__ + "img/microscope.a1f9d897.png";